import { _colors as colors } from "#tailwind-config/theme";

export type TwColors = typeof colors;

export default defineNuxtPlugin((nuxtApp) => {
  // Provide the resolved colors so they can be accessed via `const { $twColors } = useNuxtApp()`
  nuxtApp.provide("twColors", colors);
});
